import { useQuery } from '@tanstack/react-query';
import { bondsApi } from '../services/api';
import type { Bond, BondsMetadata } from '../types/bonds';

export const useBonds = () => {
  return useQuery<{ bonds: Bond[]; metadata: BondsMetadata }>({
    queryKey: ['bonds'],
    queryFn: () => bondsApi.getBonds(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
  });
};
